import { useTranslation } from 'react-i18next';

export const useTranslatedContent = () => {
  const { i18n } = useTranslation();

  const getTranslation = (item: any, field: string) => {
    if (!item || !Array.isArray(item.translations)) {
      return 'Translation not available';
    }

    const translation =
      item.translations.find((t: any) => t.languages_code === i18n.language) ||
      item.translations.find((t: any) => t.languages_code === 'uk');

    if (!translation) {
      return 'Translation not available';
    }

    return translation[field] || 'Field not found';
  };

  const getTranslationIMG = (item: any, field: string) => {
    if (!item || !Array.isArray(item.translations)) {
      return 'Translation not available';
    }

    const translation =
      item.translations_img.find((t: any) => t.languages_code === i18n.language) ||
      item.translations_img.find((t: any) => t.languages_code === 'uk');

    if (!translation) {
      return 'Translation not available';
    }

    return translation[field] || 'Field not found';
  };

  return { getTranslation, getTranslationIMG, i18n };
};
